module.exports = __webpack_public_path__ + "img/GoblinMale_Light.267b75ee.gif";